import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    numberOfProjects: 0,
    totalScans: 0,
    vulnerabilitiesAddressed: 0,
    vulnerabilitiesIdentified: 0,
    filteredOverview: {
        numberOfProjects: 0,
        totalScans: 0,
        vulnerabilitiesAddressed: 0,
        vulnerabilitiesIdentified: 0,
    }
}

export const accountOverviewSlice = createSlice({
    name: "account overview",
    initialState,
    reducers: {
        resetAcountOverview: (state) => {
            Object.assign(state, initialState)
        },
        setAccountOverview: (state, {payload}) => {
            const target = payload.target
            if(target) {
                state[target].numberOfProjects = payload.numberOfProjects
                state[target].totalScans = payload.totalScans
                state[target].vulnerabilitiesAddressed = payload.vulnerabilitiesAddressed
                state[target].vulnerabilitiesIdentified = payload.vulnerabilitiesIdentified
                return
            }
            state.numberOfProjects = payload.numberOfProjects
            state.totalScans = payload.totalScans
            state.vulnerabilitiesAddressed = payload.vulnerabilitiesAddressed
            state.vulnerabilitiesIdentified = payload.vulnerabilitiesIdentified
        }
    }
})

export const { setAccountOverview, resetAcountOverview } = accountOverviewSlice.actions
export default accountOverviewSlice.reducer